<template>
    <div class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-overflow-hidden tw-w-full tw-h-full">
        <header 
            class="tw-w-full tw-text-white tw-p-6 tw-sticky tw-block tw-bg-black">
            <span @click="$router.push({name: 'Campaigns'})" class="tw-cursor-pointer hover:tw-text-gray-500">ROON COMMSBRIDGE</span>
            <div class="tw-float-right">
                <ul class="tw-list-none">
                    <li 
                        class="hover:tw-text-gray-500 tw-mr-5 tw-cursor-pointer tw-inline-block" 
                        @click="$router.push({name: 'Campaigns'})">
                        CAMPAIGNS
                    </li>
                    <li 
                        class="hover:tw-text-gray-500 tw-mr-5 tw-cursor-pointer tw-inline-block" 
                        @click="logout">
                        SIGN OUT
                    </li>
                </ul>
            </div>
        </header>
        <div class="tw-flex-1 tw-w-full tw-overflow-auto">
            <router-view></router-view>
        </div>
    </div>
</template>
<script setup>
import RoonAuth from '@roonlabs/vue-roon-login';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route  = useRoute();

function logout() {
    RoonAuth.logout()
}
function safeRoute(name) {
    if ( route.name !== name ) {
        router.push({name})
    }
}
</script>
